
import { defineComponent } from 'vue'
import user from '@/utils/user'
import { welcomeTime, welcome } from '@/utils/util'
import { getAppName } from '@/api/base'

export default defineComponent({
    name: 'Login',
    data () {
        return {
            projectName: '欢迎使用',
            currentMode: 'mobile',
            phone: '',
            code: '',
            username: '',
            password: '',
            time: 0,
            loginMode: 'both',
            recordNumber: '',
            loginLogo: ''
        }
    },
    mounted () {
        const project_logo_square = localStorage.getItem('project_logo_square_c')
        const project_logo = localStorage.getItem('project_logo_c')
        const project_name = localStorage.getItem('project_name_c')
        if (project_logo_square && project_name) {
            user.changeFavicon(project_logo_square)
            document.title = project_name + '-登录'
        }
        if (project_logo) {
            this.loginLogo = project_logo
        }
        if (getAppName() === '蓝工盾') {
            this.loginMode = 'both'
            this.recordNumber = '京ICP备2023018104号-1'
        } else if (getAppName() === '安心优选') {
            this.loginMode = 'sms'
            this.recordNumber = '苏ICP备2022007642号-1'
        } else if (getAppName() === '企护星') {
            this.loginMode = 'both'
            this.recordNumber = '鄂ICP备2023012241号-1'
        } else if (getAppName() === '预安企护') {
            this.loginMode = 'sms'
            this.recordNumber = '浙ICP备2024055271号-1'
        } else if (getAppName() === '及时宝') {
            this.loginMode = 'both'
            this.recordNumber = '苏ICP备2025176420号-1'
        } else {
            this.loginMode = 'both'
            this.recordNumber = '测试ICP备202404101号-1'
        }
    },
    methods: {
        switchMode () {
            this.currentMode = this.currentMode === 'mobile' ? 'account' : 'mobile'
        },
        async submit () {
            if (this.currentMode === 'mobile') {
                if (!/^1\d{10}$/.test(this.phone)) {
                    this.$message.warning('请输入手机号码')
                    return
                }
                if (!this.code) {
                    this.$message.warning('请输入验证码')
                    return
                }
                await user.login({
                    mobile: this.phone,
                    smsCode: this.code,
                    loginMode: this.currentMode
                })
            } else {
                if (!this.username) {
                    this.$message.warning('请输入用户名')
                    return
                }
                if (!this.password) {
                    this.$message.warning('请输入密码')
                    return
                }
                await user.login({
                    username: this.username,
                    password: this.password,
                    loginMode: this.currentMode
                })
            }

            this.$router.push({
                path: '/'
            })
            this.$message.success(welcomeTime() + '，' + user.userName)
        },
        async getSms () {
            if (/^1\d{10}$/.test(this.phone)) {
                await user.getSms(this.phone)
                this.$message.success('短信发送成功，请注意查收！')
                this.setTime()
            } else {
                this.$message.warning('请输入手机号码')
            }
        },
        setTime () {
            this.time = 60
            const timer = setInterval(() => {
                this.time -= 1
                if (this.time === 0) {
                    clearInterval(timer)
                }
            }, 1000)
        }
    }
})
